import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/modules/shared.module';

import { AppComponent } from '../app.component';
import { LogoComponent } from './logo/logo.component';
import { TextComponent } from './text/text.component';

import { AuthGuard } from '../auth.guard';
import { AccountService } from './services/account.service';
import { RouterModule } from '@angular/router';
import { AccountComponent } from './account/account.component';
import { QuillModule } from 'ngx-quill';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    QuillModule.forRoot(),
  ],
  declarations: [LogoComponent, TextComponent, AccountComponent],
  exports: [],
  providers: [AppComponent, AuthGuard, AccountService]
})
export class AccountModule { }
